import React, { useEffect, useState } from "react";
import { Image, Accordion, Form, Button } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
    StoriesBox,
    Heading,
    ReviewImage,
    Likethamb,
    HeaidnImage,
    CientName,
    Name,
    ClientServed,
    ClientBox,
    SmallText,
    Comment,
    ClientDescription,
    SocailLink,
    LinkTitle,
    SocailList,
    SocailItem,
    ReviewDetails,
    ReviewFlag,
    CommentBox,
    AccordionIcon,
    Accordiontext,
    AccordionHeading,
    CommunitFeatureCol,
} from "./StoriesreviewFeatureStyle";
import RatingStar from "../../common/ratingStar/ratingStar";
import Likethab from "../../../assests/images/like.svg";
import LikeFilledthab from "../../../assests/images/like-filled.svg";
import MailIocn from "../../../assests/images/mail.svg";
import FacebookIcon from "../../../assests/images/facebook.svg";
import TwiterIocn from "../../../assests/images/xicon.svg";
import FlagIocn from "../../../assests/images/flag.svg";
import moment from "moment";
import NoImage from "../../../assests/images/gnp_noimg.png";
import { useDispatch } from "react-redux";
import {
    communityStoriesAction,
    communityStoriesHandler,
    flagStoryHandler,
    storieAddCommentHandler,
    storieLikeHandler,
} from "../../../redux/slices/donationCamp/communityStories-slice";
import { useSelector } from "react-redux";
import { featuredReviewHandler } from "../../../redux/slices/reviews/featuredReview";

const CommunityStoriesFeature = ({ communityStoryData, refresh, handleChange, setCommunityFeature,page }: any) => {
  
    const navigate = useNavigate();
    const dispatch: any = useDispatch();

    const { id } = useParams()

    const [flagged, setFlagged] = useState(communityStoryData?.flag);
    const [liked, setLiked] = useState(communityStoryData?.is_liked);
    const [votes, setVotes] = useState(communityStoryData?.votes_up);
    const [comment, setComment] = useState("");
    const [error, setError] = useState(false);
    const campDetails: any = useSelector(
        (state: any) => state?.campDetails?.data?.results
    );


    useEffect(() => {
        setVotes(communityStoryData?.votes_up)
        setLiked(communityStoryData?.is_liked)
    }, [communityStoryData?.votes_up, communityStoryData?.is_liked])

    useEffect(() => {
        if (communityStoryData?.flag !== undefined) {
            setFlagged(communityStoryData?.flag);
        }
    }, [communityStoryData?.flag]);
    

    // async function handleLike(e: React.MouseEvent<HTMLImageElement, MouseEvent>) {
    //   try {
    //     e.preventDefault();
    //     if (!liked || !communityStoryData?.is_liked && votes == 0) {
    //       setLiked(true);
    //       setVotes(votes + 1);
    //       dispatch(storieLikeHandler(communityStoryData?.id) as any);
    //       dispatch(communityStoriesHandler(campDetails?.id, "", 1, 10))
    //       refresh(true);
    //     }
    //   } catch (error) {
    //     console.log(error);
    //   }
    // };

    async function handleFeatureReview() {
        setCommunityFeature({})
        // dispatch(featuredReviewAction.featuredReviewSliceReset());
        dispatch(communityStoriesAction.communityStoriesSliceReset());

        try {

            const response = await dispatch(featuredReviewHandler(communityStoryData?.id));

            if (response?.status === 200) {
                await dispatch(communityStoriesHandler(campDetails?.id, "", page, 10));

                // setIsFeatured(false);
                // refresh(true);
            } else {
                console.error('Failed to feature review');

            }

        } catch (error) {

            console.error('Error featuring review:', error);
        }
    }

    async function handleLike(e: any) {
        e.preventDefault();
        try {
            // if (!token) {
            //   navigate("/signin"); // Redirect to login if the token is not present
            //   return;
            // }
            handleChange(communityStoryData?.id)
            // setLiked(true);
            // setVotes((prevVotes: any) => prevVotes + 1);


            const likeResponse = await dispatch(storieLikeHandler(communityStoryData?.id) as any);
            // if (!likeResponse || likeResponse.error) {
            //     // If the request fails, rollback the UI changes
            //     setLiked(false);
            //     setVotes((prevVotes: any) => prevVotes - 1);
            // }
            await dispatch(communityStoriesHandler(campDetails?.id, "", page, 10));
            refresh(true);
        } catch (error) {
            console.error('Like action failed:', error);
        }
    }

    async function handleComment(review_comment: string) {

        if (!error) {
            try {
                // if (!token) {
                //   navigate("/signin"); // Redirect to login if the token is not present
                //   return;
                // }
                await dispatch(storieAddCommentHandler(communityStoryData?.id, { review_comment }) as any);
                await dispatch(communityStoriesHandler(campDetails?.id, "", page, 10))
                refresh(true);
                setComment("");
            } catch (error) {
                console.log(error);
            }
        }
    };

    async function handleFlag(e: any) {
      
        e.preventDefault();
         try {
        const flagResponse = await dispatch(flagStoryHandler(communityStoryData?.id, { org_id: id }) as any);

        if (flagResponse && !flagResponse.error) {
            await dispatch(communityStoriesHandler(campDetails?.id, "", page, 10));
            refresh(true);
        } else {
            console.error("Flag request failed");
        }
    } catch (error) {
        console.error('Flag action failed:', error);
    }
        // try {
        //     // setFlagged(true);

        //     const flagResponse = await dispatch(flagStoryHandler(communityStoryData?.id, { org_id: id }) as any);
        //     if (!flagResponse || flagResponse.error) {
        //         // If the request fails, rollback the flag state
        //         setFlagged(false);
        //     }
        //     await dispatch(communityStoriesHandler(campDetails?.id, "", 1, 10));
        //     refresh(true);
        // } catch (error) {
        //     console.error('Flag action failed:', error);
        //     setFlagged(false);
        // }
    }
    // async function handleFlag(e: React.MouseEvent<HTMLImageElement, MouseEvent>) {
    //   try {
    //     e.preventDefault()
    //     if (!flagged || !communityStoryData?.flag) {
    //       dispatch(
    //         flagStoryHandler(communityStoryData?.id, {
    //           org_id: id,
    //         }) as any
    //       );
    //       dispatch(communityStoriesHandler(campDetails?.id, "", 1, 10))
    //       setFlagged(true)
    //       refresh(true);
    //     }
    //   } catch (error) {
    //     console.log(error);
    //   }
    // }

    return (
        <StoriesBox>
            <ClientBox>
                <ReviewImage>
                    <Likethamb>

                        <Image className="likeimg"
                            onClick={handleLike}
                            src={liked ? LikeFilledthab : Likethab}
                        />{" "}
                        <span>{votes}</span>
                    </Likethamb>
                </ReviewImage>
                <ClientDescription>
                    <Heading onClick={() => navigate(`/user/profile/${communityStoryData?.user_id}`)}>
                        <HeaidnImage>
                            <Image src={communityStoryData?.profile_pic ?? NoImage} />
                        </HeaidnImage>
                        <CientName>
                            <Name>{communityStoryData?.username}</Name>
                            <ClientServed>
                                {communityStoryData?.role}{" "}
                                {moment(communityStoryData?.created).format("MM/DD/YYYY")}
                            </ClientServed>


                        </CientName>

                    </Heading>
                    <CommunitFeatureCol>
                        <RatingStar
                            review={communityStoryData?.review}
                            rating={communityStoryData?.rating}
                        />
                        <SmallText>{communityStoryData?.review}</SmallText>
                        <CommentBox>
                            <Accordion>
                                <Accordion.Item eventKey={communityStoryData?.id}>
                                    <Accordion.Header>
                                        <Comment>
                                            Comment ({communityStoryData?.comments?.length})
                                        </Comment>
                                    </Accordion.Header>

                                    <Accordion.Body key={communityStoryData?.id} className="hello">
                                        {communityStoryData?.can_add_comments && (
                                            <>
                                                <Form.Control
                                                    type="text"
                                                    value={comment}
                                                    onChange={(e) => {
                                                        setComment(e.target.value);
                                                        if (error) setError(false); // Reset error when user types
                                                    }}
                                                    isInvalid={error}
                                                />
                                                {error && <Form.Control.Feedback type="invalid">Comment cannot be empty</Form.Control.Feedback>}
                                                <Button
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        if (!comment.trim()) {
                                                            setError(true);
                                                        } else {
                                                            handleComment(comment);
                                                            // Optionally clear the input after submission
                                                        }
                                                    }}
                                                >
                                                    Post
                                                </Button>
                                            </>
                                        )}
                                        {communityStoryData?.comments?.map(
                                            (comment: any, index: number) => (
                                                <>
                                                    <AccordionHeading>
                                                        <AccordionIcon>
                                                            <Image src={comment?.profile_pic} />
                                                        </AccordionIcon>
                                                        <Accordiontext>
                                                            <strong>{comment?.screen_name} </strong>{" "}
                                                            <span>
                                                                {moment(comment?.created).format(
                                                                    "MM/DD/YYYY"
                                                                )}
                                                            </span>
                                                        </Accordiontext>
                                                    </AccordionHeading>
                                                    <SmallText>{comment?.comment}</SmallText>
                                                </>
                                            )
                                        )}
                                    </Accordion.Body>
                                </Accordion.Item>
                            </Accordion>
                        </CommentBox>

                        <SocailLink>
                            <ReviewDetails>
                                <LinkTitle>Share this Review:</LinkTitle>
                                <SocailList>
                                    <SocailItem>
                                        <Link to="mailto:">
                                            <Image src={MailIocn} />
                                        </Link>
                                    </SocailItem>
                                    <SocailItem>
                                        <Link to="https://www.facebook.com" target="_blank">
                                            <Image src={FacebookIcon} />
                                        </Link>
                                    </SocailItem>
                                    <SocailItem>
                                        <Link to="https://x.com/" target="_blank">
                                            <Image src={TwiterIocn} />
                                        </Link>
                                    </SocailItem>
                                </SocailList>
                            </ReviewDetails>

                        </SocailLink>
                        {!communityStoryData?.flag && (
                            <ReviewFlag>
                                Flag Review{" "}
                                <Image className="flag-icon" src={FlagIocn} onClick={handleFlag} />
                            </ReviewFlag>
                        )}
                        {communityStoryData?.flag  && (
                            <ReviewFlag>
                                <span className="flaged">
                                    Flagged
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="20"
                                        height="20"
                                        viewBox="0 0 20 20"
                                    >
                                        <g
                                            id="vuesax_linear_flag"
                                            data-name="vuesax/linear/flag"
                                            transform="translate(-236 -380)"
                                        >
                                            <g id="flag" transform="translate(236 380)">
                                                <path
                                                    id="Vector"
                                                    d="M0,0V16.667"
                                                    transform="translate(4.292 1.667)"
                                                    fill="none"
                                                    stroke="#ffa317"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth="1.5"
                                                />
                                                <path
                                                    id="Vector-2"
                                                    data-name="Vector"
                                                    d="M0,0H9.333c2.25,0,2.75,1.25,1.167,2.833l-1,1a1.61,1.61,0,0,0,0,2.333l1,1C12.083,8.75,11.5,10,9.333,10H0"
                                                    transform="translate(4.292 3.333)"
                                                    fill="#ffa317"
                                                />
                                                <path
                                                    id="Vector-3"
                                                    data-name="Vector"
                                                    d="M0,0H20V20H0Z"
                                                    fill="none"
                                                    opacity="0"
                                                />
                                            </g>
                                        </g>
                                    </svg>
                                </span>
                            </ReviewFlag>

                        )}
                    </CommunitFeatureCol>
                    {communityStoryData?.can_featured_reivew &&
                        <Button className="unfeature-btn"
                            variant="primary"
                            onClick={handleFeatureReview}

                        >
                            Unfeature Review
                        </Button>
                    }

                </ClientDescription>
            </ClientBox>
        </StoriesBox >
    );
};

export default CommunityStoriesFeature;
